import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-difference-icon',
  templateUrl: './design-difference.component.html'
})
export class DesignDifferenceComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
